export default __webpack_public_path__ + "static/elian-bitmoji-2e91639a534989dc7a5ef2f04b4c9e2b.png";